<template>
    <div class="section-card gap-bottom">
        <img
            src="@img/ddLogo.png"
            alt="Direct Debit Guarantee logo"
            class="direct-debit-logo"
        />
        <p>
            This guarantee is offered by all banks and building societies that
            accept instructions to pay Direct Debits.
        </p>
        <p>
            If there are any changes to the amount, date or frequency of your
            Direct Debit, Legal & General Assurance Society Limited will notify
            you five working days in advance of your account being debited or as
            otherwise agreed. If you request Legal & General Assurance Society
            Limited to collect a payment, confirmation of the amount and date
            will be given.
        </p>
        <p>
            If an error is made in the payment of your Direct Debit by Legal &
            General Assurance Society Limited or your bank or building society
            you are entitled to a full and immediate refund of the amount paid
            from your bank or building society.
        </p>
        <p>
            If you receive a refund you are not entitled to, you must pay it
            back when Legal & General Assurance Society Limited asks you to.
        </p>
        <p>
            You can cancel a Direct Debit at any time by simply contacting your
            bank or building society. Written confirmation may be required.
            Please also notify us.
        </p>
    </div>
</template>
